/**
 * Series page (iPhone/Samsung Cases) interaction tracking for GA4.
 * Tracks key user interactions on series landing pages.
 */
(function () {
  'use strict';

  function track(eventName, params) {
    try {
      if (typeof gtag !== 'function') return;
      gtag('event', eventName, params);
    } catch (e) { /* 静默失败 */ }
  }

  document.addEventListener('click', function (e) {
    if (typeof gtag !== 'function') return;

    // 1. Hero CTA clicks
    var heroCta = e.target.closest('.hero-banner a, .hero-banner button');
    if (heroCta) {
      track('series_hero_cta', {
        page: document.title
      });
      return;
    }

    // 2. Category card clicks (collection list)
    var categoryCard = e.target.closest('.collection-list__item, .collection-card');
    if (categoryCard) {
      var categoryName = categoryCard.querySelector('.collection-card__link, .collection-card__info a');
      track('series_category_click', {
        category_name: categoryName ? categoryName.textContent.trim() : ''
      });
      return;
    }

    // 3. Style tab clicks (featured products tabs)
    var styleTab = e.target.closest('.featured-products__tab, .tabs-nav__item');
    if (styleTab) {
      track('series_style_tab', {
        tab_name: styleTab.textContent.trim()
      });
      return;
    }

    // 4. Product card clicks
    var productCard = e.target.closest('.featured-products__card');
    if (productCard) {
      var productName = productCard.getAttribute('title') || '';
      track('series_product_click', {
        product_name: productName,
        source: 'featured'
      });
      return;
    }
  });
})();
